import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {CheckInEnum, TaskStatusEnum} from './constant'

// [获取任务列表] http://wiki.xunlei.cn/pages/viewpage.action?pageId=127575335
export const user_click_show_task = createAsyncThunk(
  '/live/facetime/user_click_show_task',
  async (arg: any, store: any) => {
    const resp = await http.post<HiyaRes<UserTasks>>(
      '/live/facetime/user_click_show_task',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

// [点击“领取”奖励的接口] http://wiki.xunlei.cn/pages/viewpage.action?pageId=127575347
export const user_click_claim_task = createAsyncThunk(
  '/live/facetime/user_click_claim_task',
  async (
    arg: Pick<Task, 'task_id' | 'task_sub_type' | 'task_type'>,
    store: any
  ) => {
    const resp = await http.post<HiyaRes<ClaimRes>>(
      '/live/facetime/user_click_claim_task',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {xcErrorToast: true}
    )
    return resp.data.data
  }
)

// [签到详情] http://wiki.xunlei.cn/pages/viewpage.action?pageId=122790412
export const check_in_detail = createAsyncThunk(
  '/live/facetime/check_in_detail',
  async (arg: any, store: any) => {
    const resp = await http.post<HiyaRes<UserTasks>>(
      '/live/facetime/check_in_detail',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)
// [签到]  http://wiki.xunlei.cn/pages/viewpage.action?pageId=122790428
export const check_in = createAsyncThunk(
  '/live/facetime/check_in',
  async (arg: any, store: any) => {
    const resp = await http.post<HiyaRes<CheckInRes>>(
      '/live/facetime/check_in',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// [h5全局任务完成弹窗需要的信息] http://wiki.xunlei.cn/display/zdxm/user_task_complete_get_window
export const user_task_complete_get_window = createAsyncThunk(
  '/live/facetime/user_task_complete_get_window',
  async (
    arg: Pick<Task, 'task_id' | 'task_sub_type' | 'task_type'>,
    store: any
  ) => {
    const resp = await http.post<HiyaRes<GetWindowRes>>(
      '/live/facetime/user_task_complete_get_window',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)
interface TaskInfo {
  task_type: string
  task_sub_type: string
  task_id: number
}
interface CompleteWindowInfo {
  task_info: TaskInfo // 调用领取接口，服务端所需要的一些信息
  title: string // 标题
  describe: string // 描述 {任务名称}  用于展示
  reward: RewardCfg[] // 奖励信息
  claim_button_str: string //  [去领取]按钮的文案
}
interface GetWindowRes {
  err_msg: string
  data: CompleteWindowInfo // 全局弹窗--任务完成弹窗中的信息
}

export interface RewardCfg {
  reward_name: string // 任务奖励名称
  reward_num: number // 任务奖励数量
  reward_icon: string // 奖励的图标链接
  reward_type_id: number // 奖励的类型
}
export interface Task {
  task_id: number // 任务Id
  task_sub_type: string // 子任务任务类型
  task_type: string // 任务类型 日常还是新手任务
  task_title: string // 用于展示的任务标题
  task_describe: string // 任务描述
  task_icon: string // 任务图标链接
  reward: RewardCfg[] // 列表，任务奖励
  button_str: string // 按钮的文案
  button_status: TaskStatusEnum // 按钮/任务的状态
  link: string // 去完成状态下的跳转链接
}
interface NoviceTaskLstInfo {
  novice_task_lst: Task[] // 任务列表
  all_completed: boolean // 是否已经全部完成
  could_show: boolean // 是否展示
}

interface DailyTaskLstInfo {
  daily_task_lst: Task[] // 任务列表
  all_completed: boolean // 是否已经全部完成
  could_show: boolean // 是否展示
}

export interface IBigBangTask extends Task {
  sub_task_process?: number // 任务进度
  sub_task_target_process?: number // 任务目标进度
}
interface BigBangTaskLstInfo {
  big_bang_task_lst: IBigBangTask[]
  all_completed: boolean // 是否已经全部完成
  could_show: boolean // 是否展示
}
export interface UserTasks {
  err_msg?: string
  daily_task_lst_info?: DailyTaskLstInfo // 日常任务列表
  novice_task_lst_info?: NoviceTaskLstInfo // 新手任务列表
  big_bang_task_lst_info?: BigBangTaskLstInfo // 开业大酬宾任务
}
export interface CheckInDetail {
  name: string // 奖励名字
  type: number // 匹配卡=2、聊天卡=1
  scheme: string // 签到成功后的跳转行为
  time: string // 奖励时间
  count: number // 奖励数量
  status: CheckInEnum // 奖励状态 0已领取  1待领取  2无法领取
  icon: string // 图标url,
}
export interface CheckInList {
  errmsg: string
  show: boolean
  risk: boolean // 是否风控用户
  claimed: boolean // 今日是否已经领取
  title: string // 弹窗标题
  desc: string // 弹窗描述
  details: CheckInDetail[] // details 包含了本轮次每天的奖励细节，会有7条记录，由产运配置
}

export interface RewardWindowInfo {
  title: string
  reward: RewardCfg[] // 奖励信息
  go_chat_link: string // 去聊天按钮的跳转链接
  more_rewards_link: string // 查看更多奖励按钮的链接
}
export interface ClaimRes {
  err_msg?: string
  data?: RewardWindowInfo // 领取弹窗中的信息
}
interface CheckInRewardDetail {
  name: string // 奖励名字
  type: number // 聊天卡=1，匹配卡=2
  scheme: string // 签到成功后的跳转行为
  count: number // 奖励数量
  icon: string // 图标url,
}
interface CheckInRes {
  err_msg?: string
  reward_data?: CheckInRewardDetail // 领取弹窗中的信息
}
export interface InitialStateType {
  userTasks: UserTasks
  toastData: ClaimRes
  checkInList: Partial<CheckInList>
  checkInData: Partial<CheckInRes>
  windowData: Partial<GetWindowRes>
}

const initialState: InitialStateType = {
  userTasks: {},
  toastData: {},
  checkInList: {},
  checkInData: {},
  windowData: {},
}

export const UserTasksSlice = createSlice({
  name: 'UserTasks',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(user_click_show_task.fulfilled, (state, action) => {
      Object.assign(state, {userTasks: {...action.payload}})
    })
    builder.addCase(user_click_claim_task.fulfilled, (state, action) => {
      Object.assign(state, {toastData: {...action.payload}})
    })
    builder.addCase(check_in_detail.fulfilled, (state, action) => {
      Object.assign(state, {checkInList: {...action.payload}})
    })
    builder.addCase(check_in.fulfilled, (state, action) => {
      Object.assign(state, {checkInData: {...action.payload}})
    })
    builder.addCase(
      user_task_complete_get_window.fulfilled,
      (state, action) => {
        Object.assign(state, {windowData: {...action.payload}})
      }
    )
  },
})
export default UserTasksSlice.reducer
export const UserTasksActions = UserTasksSlice.actions

export const useUserTaskListState = () => {
  const data = useSelector((state) => {
    return state.UserTasks.userTasks
  })
  return data
}
